import config from './config';

const batchDelay = 1000;

let batch: Record<string, number> = {};
let timeout: any | undefined;

export async function initRum() {
  if (Math.random() > config.rum.sampleRate) {
    return;
  }

  const { getCLS, getFCP, getFID, getLCP, getTTFB } = await import(
    'web-vitals'
  );
  const metricProducers = [getCLS, getFCP, getFID, getLCP, getTTFB];

  for (const producer of metricProducers) {
    producer(onReport);
  }
}

async function onReport(metric: import('web-vitals').Metric) {
  if (!metric.isFinal) {
    return;
  }

  batch[metric.name] = metric.value;

  // each time a new metric is reported delay sending the current batch
  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(sendBatch, batchDelay);
}

async function sendBatch() {
  try {
    await fetch('/rum/report', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(batch),
    });
  } catch (e) {
    console.warn('Failed to send RUM metrics batch', e);
  }

  batch = {};
}
